export default __webpack_public_path__ + "static/media/broom.da6fede7.png";